import React from 'react';
import { uid } from '../_utils';
var Input = function (props) {
    var _a = props.id, id = _a === void 0 ? uid('input') : _a, isValid = props.isValid, max = props.max, maxLength = props.maxLength, min = props.min, pattern = props.pattern, readOnly = props.readOnly, required = props.required, step = props.step, type = props.type, _b = props.value, value = _b === void 0 ? '' : _b, onChange = props.onChange;
    var handleOnChange = function (event) {
        if (onChange && typeof onChange === 'function')
            onChange(event);
    };
    return (React.createElement("input", { className: "form-control" + (isValid ? '' : ' is-invalid'), id: id, max: max, maxLength: maxLength, min: min, pattern: pattern, readOnly: readOnly, required: required, step: step, type: type, value: value, onChange: handleOnChange }));
};
export default React.memo(Input);
